const $ = jQuery.noConflict();

// Possible search toggle filters
const filterToggles = {
   profiles: 'filter-campaigns',
   daily: 'filter-daily',
   eventsawards: 'filter-events',
   tags: 'filter-tags',
   categories: 'filter-categories',
};

export function setupFilterEvents() {
   const $filterEl = $('#filter-search-results');
   const $categoryEl = $(`#${filterToggles.categories}`);
   if ($filterEl.length) {
      $filterEl.on('click', (e) => {
         e.preventDefault();
         e.stopPropagation();
         const urlParams = new URLSearchParams(window.location.search);
         Object.entries(filterToggles)
            .forEach(([param, elId]) => {
               switch (param) {
               // categories is a dropdown
               case 'categories': {
                  const val = $categoryEl[0].value;
                  if (val && val != -1) {
                     urlParams.set(param, val);
                  }
                  break;
               }
               // the rest are checkboxes
               default:
                  if ($(`#${elId}`).is(':checked')) {
                     urlParams.set(param, 1);
                  }
                  else if (urlParams.has(param)) {
                     urlParams.delete(param);
                  }
               }
            });
         window.location.search = `?${urlParams.toString()}`;
      });
   }

   // add active class if category query option is on
   $categoryEl.on('change', () => {
      if ($categoryEl[0].value !== '-1') {
         $categoryEl.addClass('active');
      }
      else {
         $categoryEl.removeClass('active');
      }
   });
}
